export interface SntsMessage {
  sequenceNumber: number
  timestamp: number
  batteryReadingsEnabled: boolean
  flagPowerIsBelowShutdownLevel: boolean // below 3.0V
  flagPowerIsBelowWarningLevel: boolean // below 3.25V
  batteryReading: number
  portCPowerReading: number
}

// SNTS = Sequence Number Timestamp
export function decodeSntsMessage(data: Uint8Array): SntsMessage {
  const sequenceNumber = (data[0] << 16) | (data[1] << 8) | data[2]
  const timestamp = (data[3] << 16) | (data[4] << 8) | data[5]
  const statusFlags = data[6] >> 4
  const batteryReadingsEnabled = !!(statusFlags & 0x4)
  const flagPowerIsBelowShutdownLevel = !!(statusFlags & 0x2)
  const flagPowerIsBelowWarningLevel = !!(statusFlags & 0x1)
  const batteryReading = ((data[6] & 0x0f) << 8) | data[7]
  const portCPowerReading = (data[8] << 4) | ((data[9] >> 4) & 0x0f)

  return {
    sequenceNumber,
    timestamp,
    batteryReadingsEnabled,
    flagPowerIsBelowShutdownLevel,
    flagPowerIsBelowWarningLevel,
    batteryReading,
    portCPowerReading,
  }
}
